import { mapActions, mapGetters } from 'vuex';
import MeterCard from './components/MeterCard/MeterCard.vue';
import AddMeterModal from './components/AddMeterModal/AddMeterModal.vue';
import IndicatorsTable from './components/IndicatorsTable/IndicatorsTable.vue';

export default {
	components: { MeterCard, AddMeterModal, IndicatorsTable },
	data() {
		return {
			addMeterVisible: false
		}
	},
	computed: {
		...mapGetters([
			'meters',
			'currentUserID',
			'isAdmin',
			'contractNumber'
		]),
		hasMeters() {
			return this.meters.length !== 0
		}
	},
	methods: {
		...mapActions(['getAllMetters']),
	},
	beforeMount() {
		this.getAllMetters({
			userId: this.currentUserID,
			contractNumber: this.contractNumber
		});
	},
}